import React, { useEffect, useRef, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import $ from "jquery";
import { useParams } from "react-router-dom";
import { API_URL, BASE_URL } from "./Config";
import config from "./common/Config";
import { toast } from "sonner";
import generateTripSummaryPDF from "./TripSummaryPDF";
import generateTripSummaryPDF_sdm from "./generateTripSummaryPDF_sdm";
import {
  Box,
  Paper,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Link as MuiLink,
  Chip,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  RadioGroup,
  Radio,
  FormControlLabel,
  FormControl,
  InputLabel,
  Select,
  Grid,
} from "@mui/material";
import { Iconify } from "./Minimal/src/components/iconify/iconify";
import "./common/commonStyles.css";
// import "../components/css/custom-filter.css";

const OpenTripSummary = (props) => {
  const salesOrderRef = useRef(null);
  const { tripId } = useParams();
  const [tripOrder, setTripOrder] = useState([]);
  const [deliveredOrders, setDeliveredOrders] = useState([]);
  const [tripNumber, setTripNumber] = useState([]);
  const [driverName, setDriverName] = useState([]);
  const [vehicle, setVehicle] = useState([]);
  const [date, setDate] = useState([]);
  const [undeliveredOrders, setUndeliveredOrders] = useState([]);
  const [cashCollection, setCashCollection] = useState([]);
  const [totalCashCollection, setTotalCashCollection] = useState(0);
  const [chequeCollection, setChequeCollection] = useState([]);
  const [totalChequeCollection, setTotalChequeCollection] = useState(0);
  const [partialNotDeliveredBox, setPartialNotDeliveredBox] = useState([]);
  const [partialNotDeliveredPiece, setPartialNotDeliveredPiece] = useState([]);
  const [undeliveredProductsList, setUndeliveredProductsList] = useState([]);
  const [totalUndeliveredBox, setTotalUndeliveredBox] = useState(0);
  const [totalUndeliveredPcs, setTotalUndeliveredPcs] = useState(0);
  const [returnProductsList, setReturnProductsList] = useState([]);
  const [totalReturnBox, setTotalReturnBox] = useState(0);
  const [totalReturnPcs, setTotalReturnPcs] = useState(0);
  const [totalProductsBox, setTotalProductsBox] = useState([]);
  const [totalProductsPiece, setTotalProductsPiece] = useState([]);
  const [deliveredProductsBox, setDeliveredProductsBox] = useState([]);
  const [deliveredProductsPices, setDeliveredProductsPices] = useState([]);
  const [undeliveredProductsBox, setUndeliveredProductsBox] = useState([]);
  const [undeliveredProductsPices, setUndeliveredProductsPices] = useState([]);
  const [deliveredAmt, setDeliveredAmt] = useState(0);
  const [undeliveredAmt, setUndeliveredAmt] = useState(0);
  const deliveredAmtValue = parseFloat(deliveredAmt);
  const undeliveredAmtValue = parseFloat(undeliveredAmt);
  const totalAmt = parseFloat(deliveredAmtValue + undeliveredAmtValue).toFixed(
    2
  );
  const modalRef = useRef(null);
  const [deliveredOrderDetails, setDeliveredOrderDetails] = useState([]);
  const [undeliveredOrderDetails, setUndeliveredOrderDetails] = useState([]);
  const [partialUndelivered, setPartialUndelivered] = useState([]);
  const [returnDetails, setReturnDetails] = useState([]);
  const [totalManifest, setTotalManifest] = useState([]);
  const accessToken = localStorage.getItem("accessToken");
  const roleID = localStorage.getItem("roleID");
  const company_tax_type = localStorage.getItem("company_tax_type");
  const currencySymbol = localStorage.getItem("currencySymbol");
  const [isButtonDisabled, setButtonDisabled] = useState(true);
  const [reassignTripData, setReassignTripData] = useState([]);
  const [driverCollectData, setDriverCollectData] = useState([]);
  const [showDriverCollectDialog, setShowDriverCollectDialog] = useState(false);
  const [showReassignDialog, setShowReassignDialog] = useState(false);
  const [showUndeliveredDialog, setShowUndeliveredDialog] = useState(false);
  const [showOrdersDeliveredDialog, setShowOrdersDeliveredDialog] = useState(false);
  const [showOrdersUndeliveredDialog, setShowOrdersUndeliveredDialog] = useState(false);
  const [showPartialUndeliveredDialog, setShowPartialUndeliveredDialog] = useState(false);
  const [showUndeliveredProductsDialog, setShowUndeliveredProductsDialog] = useState(false);
  const [showReturnDetailsDialog, setShowReturnDetailsDialog] = useState(false);
  const [returnMenuAnchor, setReturnMenuAnchor] = useState({ el: null, returnId: null });
  const [reassignComment, setReassignComment] = useState("");
  const [undeliveredTripData, setUndeliveredTripData] = useState("");
  const [totalProductsList, setTotalProductsList] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [paymentType, setPaymentType] = useState("");
  const [isChequeVisible, setChequeVisible] = useState(false);
  const [driverCollectForm, setDriverCollectForm] = useState({
    amount: "",
    type: "",
    paid_by: "",
    cheque: "",
    remark: "",
  });
  const [loading, setLoading] = useState(false);
  const [menuAnchor, setMenuAnchor] = useState({ el: null, rowData: null });
  const token = localStorage.getItem('token');

  const handleMenuOpen = (event, rowData) => {
    event.stopPropagation();
    setMenuAnchor({ el: event.currentTarget, rowData });
  };

  const handleMenuClose = (event) => {
    if (event) {
      event.stopPropagation();
    }
    setMenuAnchor({ el: null, rowData: null });
  };

  const handleReturnMenuOpen = (event, returnId) => {
    event.stopPropagation();
    setReturnMenuAnchor({ el: event.currentTarget, returnId });
  };

  const handleReturnMenuClose = () => {
    setReturnMenuAnchor({ el: null, returnId: null });
  };

  const handleReturnMenuAction = async (action, returnId) => {
    handleReturnMenuClose();
    const isAcceptReturn = action === 'accept';
    const urlRejectLink = `${config.API_URL}/add_reject_return`;
    const urlAcceptLink = `${config.API_URL}/add_accept_return`;

    if (isAcceptReturn) {
      const confirmed = window.confirm("Are you sure you want to create the Credit Note?");
      if (confirmed) {
        await sendApiRequest(urlAcceptLink, returnId, "yes");
      } else {
        await sendApiRequest(urlAcceptLink, returnId, "no");
      }
    } else {
      const confirmed = window.confirm("Are you sure you want reject order?");
      if (confirmed) {
        await sendApiRequest(urlRejectLink, returnId);
      }
    }
  };

  const handleMenuAction = (action, rowData) => {
    handleMenuClose();
    if (action === 'reassign') {
      setReassignTripData(rowData);
      viewVechMdl(rowData);
    } else if (action === 'undelivered') {
      setUndeliveredTripData(rowData);
      viewUndeliveredMdl(rowData);
    } else if (action === 'edit') {
      const url = accessToken === 'sdm'
        ? `${config.BASE_URL}/trip/Edit_delivered_invoice_sdm/${tripId}/${rowData.orderId}`
        : `${config.BASE_URL}/trip/Edit_delivered_invoice/${tripId}/${rowData.orderId}`;
      window.location.href = url;
    } else if (action === 'proof') {
      if (rowData.proof_of_delivery) {
        $("#proofDeliveryModalImg").attr("src", rowData.proof_of_delivery);
        $("#downloadProofBtn").attr("href", rowData.proof_of_delivery);
        const modal = new window.bootstrap.Modal(
          document.getElementById("proofDeliveryModal")
        );
        modal.show();
      } else {
        toast.info("No proof of delivery image available");
      }
    }
  };

  const handleReassignCommentChange = (event) => {
    setReassignComment(event.target.value);
  };

  const checkIfButtonShouldBeDisabled = (tripOrderDetails) => {
    const allDelivered = tripOrderDetails.every(
      (order) =>
        order.sale_status === "Delivered" || order.sale_status === "Undelivered"
    );
    setButtonDisabled(!allDelivered);
  };

  useEffect(() => {
    const calculateTotalPrice = () => {
      const total = cashCollection.reduce((acc, product) => {
        const price = parseFloat(product.cashCollected);
        if (!isNaN(price)) {
          return acc + price;
        }
        return acc;
      }, 0);
      setTotalCashCollection(total.toFixed(2)); // Format to 2 decimal places
    };
    calculateTotalPrice();

    const calculateTotalCheque = () => {
      const total = chequeCollection.reduce((acc, product) => {
        const price = parseFloat(product.chequeAmount);
        if (!isNaN(price)) {
          return acc + price;
        }
        return acc;
      }, 0);
      setTotalChequeCollection(total.toFixed(2)); // Format to 2 decimal places
    };
    calculateTotalCheque();

    let pieces = 0;
    let boxes = 0;
    const calculateUndeliveredProducts = () => {
      const total = undeliveredProductsList.reduce((acc, product) => {
        const pdtQty = parseFloat(product.qty);
        if (!isNaN(pdtQty)) {
          if (product.qtyType === "piece") {
            pieces += pdtQty;
          } else if (product.qtyType === "box") {
            boxes += pdtQty;
          }
        }
      }, 0);
      setTotalUndeliveredBox(boxes);
      setTotalUndeliveredPcs(pieces);
    };
    calculateUndeliveredProducts();

    let returnPcs = 0;
    let returnBox = 0;
    const calculateReturnProducts = () => {
      const total = returnProductsList.reduce((acc, product) => {
        const pdtQty = parseFloat(product.qty);
        if (!isNaN(pdtQty)) {
          if (product.qtyType === "piece") {
            returnPcs += pdtQty;
          } else if (product.qtyType === "box") {
            returnBox += pdtQty;
          }
        }
      }, 0);
      setTotalReturnBox(returnBox);
      setTotalReturnPcs(returnPcs);
    };
    calculateReturnProducts();
  }, [
    cashCollection,
    chequeCollection,
    undeliveredProductsList,
    returnProductsList,
  ]);

  useEffect(() => {
    if (!accessToken) {
      window.location.href = `${config.BASE_URL}/login`;
      return;
    }
    fetchData();
  }, [tripId, accessToken]);

  useEffect(() => {
    setFilteredProducts([]);
    if (Array.isArray(totalProductsList)) {
      const filtered = totalProductsList.filter(
        (product) => product.sale_id == undeliveredTripData.orderId
      );

      setFilteredProducts(filtered);
    }
  }, [totalProductsList, undeliveredTripData.orderId]);

  const fetchData = async () => {
    if (!accessToken) {
      window.location.href = `${config.BASE_URL}/login`;
      return;
    }

    setLoading(true);
    const formData = new FormData();
    formData.append("tripId", tripId);

    try {
      const response = await fetch(`${config.API_URL}/get-trip-summary`, {
        method: "POST",
        headers: {
          authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const json = await response.json();
      if (json?.data && Array.isArray(json.data.trip_order_details)) {
        const tripData = json.data;
        setTripOrder(tripData.trip_order_details);
        checkIfButtonShouldBeDisabled(tripData.trip_order_details);
        setTotalProductsList(tripData.total_products_list);
        setDeliveredOrders(tripData.deliverySummary.delivered_orders);
        setTripNumber(tripData.trip_number);
        setDriverName(tripData.driver);
        setVehicle(tripData.vehicle);
        setDate(tripData.date);
        setUndeliveredOrders(tripData.deliverySummary.undelivered_orders);
        setCashCollection(
          tripData.payment_collection.cash_collection_details
        );
        setChequeCollection(
          tripData.payment_collection.cheque_collection_details
        );
        setPartialNotDeliveredBox(tripData.partial_not_delivered_box);
        setPartialNotDeliveredPiece(tripData.partial_not_delivered_piece);
        setUndeliveredProductsList(tripData.undelivered_products_list);
        setReturnProductsList(tripData.return_products_list);
        setTotalProductsBox(tripData.total_products_box);
        setTotalProductsPiece(tripData.total_products_piece);
        setDeliveredProductsBox(tripData.delivered_products_box);
        setDeliveredProductsPices(tripData.delivered_products_piece);
        setUndeliveredProductsBox(tripData.undelivered_products_box);
        setUndeliveredProductsPices(tripData.undelivered_products_piece);
        setDeliveredAmt(
          parseFloat(tripData.deliverySummary.delivered_amt).toFixed(2)
        );
        setUndeliveredAmt(
          parseFloat(tripData.deliverySummary.undelivered_amt).toFixed(2)
        );
        setDeliveredOrderDetails(
          tripData.deliverySummary.delivered_order_details
        );
        setUndeliveredOrderDetails(
          tripData.deliverySummary.undelivered_order_details
        );
        setPartialUndelivered(tripData.partial_undelivered);
        setReturnDetails(tripData.return_details);
        setTotalManifest(tripData.total_manifest);
      }
    } catch (error) {
      toast.error("Failed to load trip summary");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    $(document)
      .off("click", "#downloadProofBtn")
      .on("click", "#downloadProofBtn", function (e) {
        e.preventDefault();

        const imageUrl = $(this).attr("href");
        const apiUrl = `${config.API_URL}/download-image?url=${encodeURIComponent(imageUrl)}`;

        fetch(apiUrl)
          .then((response) => {
            if (!response.ok) {
              throw new Error("Download failed");
            }
            return response.blob();
          })
          .then((blob) => {
            const blobUrl = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = blobUrl;
            link.download = "proof_of_delivery.jpg";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(blobUrl);
          })
          .catch((error) => {
            console.error("Error downloading image:", error);
            alert("Failed to download image. Please try again.");
          });
      });
  }, []);

  const viewVechMdl = (rowData) => {
    setReassignTripData(rowData);
    setReassignComment("");
    setShowReassignDialog(true);
  };
  const viewDriverCollectMdl = (rowData) => {
    setDriverCollectData(rowData);
    setDriverCollectForm({
      amount: rowData.driver_collect || "",
      type: rowData.type || "",
      paid_by: "",
      cheque: "",
      remark: "",
    });
    setPaymentType("");
    setChequeVisible(false);
    setShowDriverCollectDialog(true);
  };
  const viewUndeliveredMdl = (rowData) => {
    setUndeliveredTripData(rowData);
    setReassignComment("");
    setShowUndeliveredDialog(true);
  };

  const ReassignFormData = async () => {
    const reason = reassignComment;

    if (!reason) {
      toast.error("Please enter reason for Reassign");
      return;
    } else {
      const formData = new FormData();
      formData.append("reason_reassign", reason);
      formData.append("id", reassignTripData.orderId);
      formData.append("manifest_id", reassignTripData.manifestId);

      const apistatusUrl = `${config.API_URL}/reassign_order_by_manager`;
      try {
        const response = await fetch(apistatusUrl, {
          method: "POST",
          headers: {
            authorization: `Bearer ${accessToken}`,
          },
          body: formData,
        });

        if (!response.ok) {
          toast.error("Trip Reassign Failed");
          return;
        }

        const data = await response.json();

        if (data.success == true) {
          toast.success("Trip Reassign successfully.");
          setTimeout(() => {
            window.location.href = `${config.BASE_URL}/open_trips/trip_summary/${tripId}`;
          }, 500);
        } else {
          toast.error("Trip Reassign Failed");
        }
      } catch (error) {
        toast.error("Error rejecting order. Please try again.");
      }
    }
  };

  // Define the async click handler function
  const handleAddStockClick = async (event) => {
    event.preventDefault();
    const button = event.target;
    const productId = button.getAttribute("product-id");
    const orderId = button.getAttribute("order-id");
    const orderType = button.getAttribute("order-type");

    const formData = new FormData();
    formData.append("productId", productId);
    formData.append("orderId", orderId);
    formData.append("order_type", orderType);
    const apiAddStockUrl = `${API_URL}/addstock_partial_undelivered`;
    try {
      const response = await fetch(apiAddStockUrl, {
        method: "POST",
        headers: {
          // 'Content-Type': 'application/json',
          authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      });

      if (!response.ok) {
        toast.error("Something went wrong, try again");
        return;
      }
      const data = await response.json();
      if (data.success) {
        toast.success("Stock added successfully");
      }

      fetchData();
    } catch (error) {
      toast.error("Error. Please try again.");
    }
  };
  const handleGeneratePDF = (e, tripId) => {
    if (accessToken == "sdm") {
      generateTripSummaryPDF_sdm(tripId);
    } else {
      generateTripSummaryPDF(tripId);
    }
  };

  const handleCompleteTrip = async () => {
    try {
      const userId = localStorage.getItem("userId");

      const formData = new FormData();
      formData.append("user_id", userId);
      formData.append("trip_id", tripId);

      const apiUrl = `${config.API_URL}/complete_trip`;
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();
      if (data.success == true) {
        toast.success("Trip Completed successfully.");
        setTimeout(() => {
          window.location.href = `${config.BASE_URL}/complete_trips`;
        }, 500);
      } else {
        toast.error("Trip Completed Failed");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const UndeliveredFormData = async () => {
    const reason = reassignComment;

    if (!reason) {
      toast.error("Please enter reason for Undelivered");
      return;
    } else {
      const formData = new FormData();
      formData.append("reason_reassign", reason);
      formData.append("id", undeliveredTripData.orderId);

      const apistatusUrl = `${config.API_URL}/order_undelivered`;
      try {
        const response = await fetch(apistatusUrl, {
          method: "POST",
          headers: {
            authorization: `Bearer ${accessToken}`,
          },
          body: formData,
        });

        if (!response.ok) {
          toast.error("Trip Undelivered Failed");
          return;
        }

        const data = await response.json();

        if (data.success == true) {
          toast.success("Trip Undelivered successfully.");
          setShowUndeliveredDialog(false);
          setReassignComment("");
          setTimeout(() => {
            window.location.href = `${config.BASE_URL}/open_trips/trip_summary/${tripId}`;
          }, 500);
        } else {
          toast.error("Trip Undelivered Failed");
        }
      } catch (error) {
        toast.error("Error. Please try again.");
      }
    }
  };

  const handelAcceptReturnList = async (event) => {
    const id = event.target.getAttribute("data-id");
    const isAcceptReturn = event.target.classList.contains("deductionbtn");

    const urlRejectLink = `${config.API_URL}/add_reject_return`;
    const urlAcceptLink = `${config.API_URL}/add_accept_return`;
    if (isAcceptReturn) {
      const confirmed = window.confirm("Are you sure you want to create the Credit Note?");
      if (confirmed) {
        await sendApiRequest(urlAcceptLink, id, "yes");
      } else {
        await sendApiRequest(urlAcceptLink, id, "no");
      }
    } else {
      const confirmed = window.confirm("Are you sure you want reject order?");
      if (confirmed) {
        await sendApiRequest(urlRejectLink, id);
      }
    }
  };

  const sendApiRequest = async (url, id, allocation = null) => {
    const formData = new FormData();

    formData.append("id", id);
    if (allocation) {
      formData.append("allocation", allocation);
    }

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      });

      const data = await response.json();
      const msg = data.message;
      if (data) {
        toast.success("Order rejected successfully.");
        setTimeout(() => {
          window.location.href = `${config.BASE_URL}/open_trips/trip_summary/${tripId}`;
        }, 500);
      } else {
        toast.error(msg || "Operation failed");
      }
    } catch (error) {
      console.error("API request failed:", error);
      return null; // Return null or handle error gracefully
    }
  };
  const handlePaymentTypeChange = (e) => {
    const selectedType = e.target.value;
    setPaymentType(selectedType);
    setDriverCollectForm((prev) => ({ ...prev, paid_by: selectedType }));
    setChequeVisible(selectedType === "Cheque");
  };

  const handleDriverCollectFormChange = (field, value) => {
    setDriverCollectForm((prev) => ({ ...prev, [field]: value }));
  };
  const handleDriverCollectSubmit = async (event) => {
    event.preventDefault();

    const id = driverCollectData.orderId;
    const amount = driverCollectForm.amount;
    const cheque = driverCollectForm.cheque;
    const paid_by = driverCollectForm.paid_by;
    const type = driverCollectForm.type;
    const remark = driverCollectForm.remark;

    const formData = new FormData();
    formData.append("id", id);
    formData.append("amount", amount);
    formData.append("type", type);
    formData.append("remark", remark);
    formData.append("trip_id", tripId);
    formData.append("chequeNo", cheque);
    formData.append("paid_by", paid_by);

    const apiUrl = `${API_URL}/update_driver_collect`;
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();
      if (data.success) {
        toast.success("Driver collect updated successfully.");
        setShowDriverCollectDialog(false);
        setDriverCollectForm({
          amount: "",
          type: "",
          paid_by: "",
          cheque: "",
          remark: "",
        });
        setTimeout(() => {
          window.location.href = `${config.BASE_URL}/open_trips/trip_summary/${tripId}`;
        }, 500);
      } else {
        toast.error("Failed to update driver collect.");
      }
    } catch (error) {
      toast.error("An error occurred while updating driver collect.");
    }
  };

  return (
    <>
      <Box className="page-container">

          <Paper
            className="paper-style"
          >
            <Box sx={{ px: 2, py:1 }}>
              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 2 }}>
                <Typography sx={{ fontWeight: 500, color: "#212b36", fontSize: "1.125rem" }}>
                  Trip Summary - {tripNumber}
                </Typography>
                <Box sx={{ display: "flex", alignItems: "center", gap: 2, flexWrap: "wrap" }}>
                  <Typography variant="body2" sx={{ color: "#637381", fontSize: "0.875rem" }}>
                    <span style={{ fontWeight: 500, color: "#000" }}>Date - </span> <span style={{ color: "#000" }}>{date}</span>
                  </Typography>
                  <Typography variant="body2" sx={{ color: "#637381", fontSize: "0.875rem" }}>
                    <span style={{ fontWeight: 500, color: "#000" }}>Driver - </span> <span style={{ color: "#000" }}>{driverName}</span>
                  </Typography>
                  <Typography variant="body2" sx={{ color: "#637381", fontSize: "0.875rem" }}>
                    <span style={{ fontWeight: 500, color: "#000" }}>Vehicle - </span> <span style={{ color: "#000" }}>{vehicle}</span>
                  </Typography>
                  <Button
                    variant="contained"
                    onClick={(e) => handleGeneratePDF(e, tripId)}
                    className="button-variant-contained"
                  >
                    Print
                  </Button>
                </Box>
              </Box>
            </Box>
            <Box sx={{ p: 2 }}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} lg={3}>
                  <Paper
                    elevation={0}
                    sx={{
                      border: "1px solid rgba(145, 158, 171, 0.16)",
                      borderRadius: 1,
                      overflow: "hidden",
                    }}
                  >
                    <Table size="small" className="table-cell-border">
                      <TableBody>
                        <TableRow className="table-cell-header">
                          <TableCell sx={{ fontWeight: 500, fontSize: "0.775rem", color: "#000", borderBottom: "1px solid rgba(145, 158, 171, 0.16)" }}>
                            Orders Delivered
                          </TableCell>
                          <TableCell sx={{ fontSize: "0.875rem", color: "#000", borderBottom: "1px solid rgba(145, 158, 171, 0.16)" }}>
                            <MuiLink
                              component="button"
                              onClick={() => setShowOrdersDeliveredDialog(true)}
                              sx={{
                                color: "inherit",
                                textDecoration: "underline",
                                textDecorationColor: "currentColor",
                                textUnderlineOffset: "2px",
                                cursor: "pointer",
                                "&:hover": {
                                  textDecoration: "underline",
                                },
                              }}
                            >
                              {deliveredOrders}
                            </MuiLink>
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell sx={{ fontWeight: 500, fontSize: "0.775rem", color: "#000", borderBottom: "1px solid rgba(145, 158, 171, 0.16)" }}>
                            Orders Undelivered
                          </TableCell>
                          <TableCell sx={{ fontSize: "0.775rem", color: "#000", borderBottom: "1px solid rgba(145, 158, 171, 0.16)" }}>
                            <MuiLink
                              component="button"
                              onClick={() => setShowOrdersUndeliveredDialog(true)}
                              sx={{
                                color: "inherit",
                                textDecoration: "underline",
                                textDecorationColor: "currentColor",
                                textUnderlineOffset: "2px",
                                cursor: "pointer",
                                "&:hover": {
                                  textDecoration: "underline",
                                },
                              }}
                            >
                              {undeliveredOrders}
                            </MuiLink>
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell sx={{ fontWeight: 500, fontSize: "0.775rem", color: "#000", borderBottom: "1px solid rgba(145, 158, 171, 0.16)" }}>
                            Cash Collected
                          </TableCell>
                          <TableCell sx={{ fontSize: "0.775rem", color: "#000", borderBottom: "1px solid rgba(145, 158, 171, 0.16)" }}>
                            {currencySymbol} {totalCashCollection}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell sx={{ fontWeight: 500, fontSize: "0.775rem", color: "#000" }}>
                            Cheque (0)
                          </TableCell>
                          <TableCell sx={{ fontSize: "0.775rem", color: "#212b36" }}>
                            {currencySymbol} {totalChequeCollection}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </Paper>
                </Grid>
                <Grid item xs={12} sm={6} lg={3}>
                  <Paper
                    elevation={0}
                    sx={{
                      border: "1px solid rgba(145, 158, 171, 0.16)",
                      borderRadius: 1,
                      overflow: "hidden",
                    }}
                  >
                    <Table size="small" className="table-cell-border">
                      <TableHead>
                        <TableRow className="table-cell-header">
                          <TableCell sx={{ fontWeight: 600, fontSize: "0.75rem", color: "#212b36", borderBottom: "1px solid rgba(145, 158, 171, 0.16)", width: "70%" }}>
                            Return Goods
                          </TableCell>
                          <TableCell sx={{ fontWeight: 600, fontSize: "0.75rem", color: "#212b36", borderBottom: "1px solid rgba(145, 158, 171, 0.16)", width: "30%" }}>
                            Box
                          </TableCell>
                          <TableCell sx={{ fontWeight: 600, fontSize: "0.75rem", color: "#212b36", borderBottom: "1px solid rgba(145, 158, 171, 0.16)", width: "30%" }}>
                            Pcs
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow>
                          <TableCell sx={{ fontSize: "0.775rem", color: "#000", borderBottom: "1px solid rgba(145, 158, 171, 0.16)" }}>
                            <MuiLink
                              component="button"
                              onClick={() => setShowPartialUndeliveredDialog(true)}
                              sx={{
                                color: "#000",
                                textDecoration: "underline",
                                textDecorationColor: "currentColor",
                                textUnderlineOffset: "2px",
                                cursor: "pointer",
                                "&:hover": {
                                  textDecoration: "underline",
                                },
                              }}
                            >
                              Partial Undeliv.
                            </MuiLink>
                          </TableCell>
                          <TableCell sx={{ fontSize: "0.775rem", color: "#000", borderBottom: "1px solid rgba(145, 158, 171, 0.16)" }}>
                            {partialNotDeliveredBox}
                          </TableCell>
                          <TableCell sx={{ fontSize: "0.775rem", color: "#000", borderBottom: "1px solid rgba(145, 158, 171, 0.16)" }}>
                            {partialNotDeliveredPiece}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell sx={{ fontSize: "0.775rem", color: "#000", borderBottom: "1px solid rgba(145, 158, 171, 0.16)" }}>
                            <MuiLink
                              component="button"
                              onClick={() => setShowUndeliveredProductsDialog(true)}
                              sx={{
                                color: "inherit",
                                textDecoration: "underline",
                                textDecorationColor: "currentColor",
                                textUnderlineOffset: "2px",
                                cursor: "pointer",
                                "&:hover": {
                                  textDecoration: "underline",
                                },
                              }}
                            >
                              Undelivered
                            </MuiLink>
                          </TableCell>
                          <TableCell sx={{ fontSize: "0.775rem", color: "#000", borderBottom: "1px solid rgba(145, 158, 171, 0.16)" }}>
                            {totalUndeliveredBox}
                          </TableCell>
                          <TableCell sx={{ fontSize: "0.775rem", color: "#000", borderBottom: "1px solid rgba(145, 158, 171, 0.16)" }}>
                            {totalUndeliveredPcs}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell sx={{ fontSize: "0.775rem", color: "#000" }}>
                            <MuiLink
                              component="button"
                              onClick={() => setShowReturnDetailsDialog(true)}
                              sx={{
                                color: "inherit",
                                textDecoration: "underline",
                                textDecorationColor: "currentColor",
                                textUnderlineOffset: "2px",
                                cursor: "pointer",
                                "&:hover": {
                                  textDecoration: "underline",
                                },
                              }}
                            >
                              Return
                            </MuiLink>
                          </TableCell>
                          <TableCell sx={{ fontSize: "0.775rem", color: "#000" }}>
                            {totalReturnBox}
                          </TableCell>
                          <TableCell sx={{ fontSize: "0.775rem", color: "#000" }}>
                            {totalReturnPcs}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </Paper>
                </Grid>
                <Grid item xs={12} sm={6} lg={3}>
                  <Paper
                    elevation={0}
                    sx={{
                      border: "1px solid rgba(145, 158, 171, 0.16)",
                      borderRadius: 1,
                      overflow: "hidden",
                    }}
                  >
                    <Table size="small" className="table-cell-border">
                      <TableHead>
                        <TableRow className="table-cell-header">
                          <TableCell sx={{ fontWeight: 600, fontSize: "0.75rem", color: "#212b36", borderBottom: "1px solid rgba(145, 158, 171, 0.16)", width: "70%" }}>
                            &nbsp;
                          </TableCell>
                          <TableCell sx={{ fontWeight: 600, fontSize: "0.75rem", color: "#212b36", borderBottom: "1px solid rgba(145, 158, 171, 0.16)", width: "30%" }}>
                            Box
                          </TableCell>
                          <TableCell sx={{ fontWeight: 600, fontSize: "0.75rem", color: "#212b36", borderBottom: "1px solid rgba(145, 158, 171, 0.16)", width: "30%" }}>
                            Pcs
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow>
                          <TableCell sx={{ fontWeight: 500, fontSize: "0.775rem", color: "#000", borderBottom: "1px solid rgba(145, 158, 171, 0.16)" }}>
                            Total Products
                          </TableCell>
                          <TableCell sx={{ fontSize: "0.775rem", color: "#000", borderBottom: "1px solid rgba(145, 158, 171, 0.16)" }}>
                            {totalProductsBox}
                          </TableCell>
                          <TableCell sx={{ fontSize: "0.775rem", color: "#000", borderBottom: "1px solid rgba(145, 158, 171, 0.16)" }}>
                            {totalProductsPiece}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell sx={{ fontWeight: 500, fontSize: "0.775rem", color: "#000", borderBottom: "1px solid rgba(145, 158, 171, 0.16)" }}>
                            Delivered
                          </TableCell>
                          <TableCell sx={{ fontSize: "0.775rem", color: "#000", borderBottom: "1px solid rgba(145, 158, 171, 0.16)" }}>
                            {deliveredProductsBox}
                          </TableCell>
                          <TableCell sx={{ fontSize: "0.775rem", color: "#000", borderBottom: "1px solid rgba(145, 158, 171, 0.16)" }}>
                            {deliveredProductsPices}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell sx={{ fontWeight: 500, fontSize: "0.775rem", color: "#000" }}>
                            Undelivered
                          </TableCell>
                          <TableCell sx={{ fontSize: "0.775rem", color: "#000" }}>
                            {undeliveredProductsBox}
                          </TableCell>
                          <TableCell sx={{ fontSize: "0.775rem", color: "#000" }}>
                            {undeliveredProductsPices}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </Paper>
                </Grid>
                <Grid item xs={12} sm={6} lg={3}>
                  <Paper
                    elevation={0}
                    sx={{
                      border: "1px solid rgba(145, 158, 171, 0.16)",
                      borderRadius: 1,
                      overflow: "hidden",
                    }}
                  >
                    <Table size="small" className="table-cell-border">
                      <TableBody>
                        <TableRow>
                          <TableCell sx={{ fontWeight: 500, fontSize: "0.775rem", color: "#000", borderBottom: "1px solid rgba(145, 158, 171, 0.16)" }}>
                            Delivered AMT
                          </TableCell>
                          <TableCell sx={{ fontSize: "0.775rem", color: "#000", borderBottom: "1px solid rgba(145, 158, 171, 0.16)" }}>
                            {currencySymbol} {deliveredAmt}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell sx={{ fontWeight: 500, fontSize: "0.775rem", color: "#000", borderBottom: "1px solid rgba(145, 158, 171, 0.16)" }}>
                            Undeliverd AMT
                          </TableCell>
                          <TableCell sx={{ fontSize: "0.775rem", color: "#000", borderBottom: "1px solid rgba(145, 158, 171, 0.16)" }}>
                            {currencySymbol} {undeliveredAmt}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell sx={{ fontSize: "0.775rem", color: "#000", borderBottom: "1px solid rgba(145, 158, 171, 0.16)" }}>
                            &nbsp;
                          </TableCell>
                          <TableCell sx={{ fontSize: "0.775rem", color: "#000", borderBottom: "1px solid rgba(145, 158, 171, 0.16)" }}>
                            &nbsp;
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell sx={{ fontWeight: 600, fontSize: "0.8rem", color: "#000" }}>
                            Total
                          </TableCell>
                          <TableCell sx={{ fontWeight: 600, fontSize: "0.8rem", color: "#000" }}>
                            {currencySymbol} {totalAmt}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </Paper>
                </Grid>
              </Grid>
            </Box>
          </Paper>

          <Box sx={{ mt: 3 }}>
            <Paper
              elevation={0}
              sx={{
                borderRadius: 2,
                border: "1px solid rgba(145, 158, 171, 0.16)",
                overflow: "hidden",
                backgroundColor: "#fff"
              }}
            >
              <Box sx={{ px: 2, py: 2 }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 600, color: "#212b36" }}>
                  Total Manifests: {totalManifest}
                </Typography>
              </Box>
              <TableContainer sx={{ width: "100%" }}>
                <Table
                  size="medium"
                  className="table-cell-border"
                  sx={{
                    tableLayout: "auto",
                    
                  }}
                >
                  <TableHead>
                    <TableRow className="table-cell-header">
                      {[
                        "#",
                        "Customers (A/C No)",
                        "Manifest No",
                        "Order ID",
                        "Post code",
                        "Route",
                        "Inv. Amt",
                        "Collected",
                        "Type",
                        "Status",
                        "Action"
                      ].map((header) => (
                        <TableCell
                          key={header}
                          align={header === "#" || header === "Action" ? "center" : header.includes("Amt") || header === "Collected" ? "right" : "left"}
                     
                        >
                          {header}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {loading ? (
                      <TableRow>
                        <TableCell colSpan={11} align="center" sx={{ py: 4 }}>
                          <Typography variant="body2" color="text.secondary">
                            Loading...
                          </Typography>
                        </TableCell>
                      </TableRow>
                    ) : tripOrder.length > 0 ? (
                      tripOrder.map((row, index) => (
                        <TableRow
                          key={row.orderId || index}
                          hover
                          className="table-cell-border"
                        >
                          <TableCell align="center" sx={{ py: 1, fontSize: "0.75rem"}}>
                            {index + 1}
                          </TableCell>
                          <TableCell sx={{ py: 1, fontSize: "0.75rem" }}>
                            {row.customerName} ({row.customerAccountNo})
                          </TableCell>
                          <TableCell sx={{ py: 1, fontSize: "0.75rem" }}>
                            {row.manifestId || ''}
                          </TableCell>
                          <TableCell align="center" sx={{ py: 1, fontSize: "0.75rem" }}>
                            <MuiLink
                              href={`${BASE_URL}/trip_summary/print/${row.orderId}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              sx={{
                                color: "inherit",
                                textDecoration: "underline !important",
                                textDecorationColor: "currentColor",
                                textUnderlineOffset: "2px",
                                "&:hover": {
                                  textDecoration: "underline !important",
                                  textDecorationColor: "currentColor"
                                }
                              }}
                            >
                              {row.referenceNo}
                            </MuiLink>
                          </TableCell>
                          <TableCell align="center" sx={{ py: 1, fontSize: "0.75rem" }}>
                            {row.postCode || ''}
                          </TableCell>
                          <TableCell align="center" sx={{ py: 1, fontSize: "0.75rem" }}>
                            {row.route || ''}
                          </TableCell>
                          <TableCell align="right" sx={{ py: 1, fontSize: "0.75rem", fontWeight: 500 }}>
                            {row.grand_total || ''}
                          </TableCell>
                          <TableCell align="center" sx={{ py: 1, fontSize: "0.75rem" }}>
                            {roleID !== '20' ? (
                              <MuiLink
                                href="#"
                                onClick={(e) => {
                                  e.preventDefault();
                                  setDriverCollectData(row);
                                  viewDriverCollectMdl(row);
                                }}
                                sx={{
                                  color: "inherit",
                                  textDecoration: "underline !important",
                                  textDecorationColor: "currentColor",
                                  textUnderlineOffset: "2px",
                                  cursor: "pointer",
                                  "&:hover": {
                                    textDecoration: "underline !important",
                                    textDecorationColor: "currentColor"
                                  }
                                }}
                              >
                                {row.driver_collect || ''}
                              </MuiLink>
                            ) : (
                              <Typography sx={{ color: "#f14240" }}>
                                {row.driver_collect || ''}
                              </Typography>
                            )}
                          </TableCell>
                          <TableCell align="center" sx={{ py: 1, fontSize: "0.75rem", color: "#212b36" }}>
                            {row.type && row.type.trim() !== "" ? row.type : "Un-paid"}
                          </TableCell>
                          <TableCell align="center" sx={{ py: 1, fontSize: "0.75rem", color: "#212b36" }}>
                            <Chip
                              label={row.sale_status}
                              size="small"
                              color="primary"
                              sx={{
                                backgroundColor: "#FFD399",
                                color: "#000",
                                fontWeight: 500,
                                fontSize: '0.7rem',
                                height: 24,
                                "&:hover": {
                                  backgroundColor: "#FFD399",
                                  color: "#000",
                                }
                           
                              }}
                            />
                          </TableCell>
                          <TableCell align="center" sx={{ py: 1, fontSize: "0.75rem", color: "#212b36" }}>
                            {(row.sale_status === "Intransit" || row.sale_status === "Delivered") && roleID !== '20' ? (
                              <IconButton
                                size="small"
                                onClick={(e) => handleMenuOpen(e, row)}
                                sx={{
                                  color: "#637381",
                                  "&:hover": {
                                    backgroundColor: "rgba(0, 0, 0, 0.04)"
                                  }
                                }}
                              >
                                <Iconify icon="eva:more-vertical-fill" width={18} height={18} />
                              </IconButton>
                            ) : ''}
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={11} align="center" sx={{ py: 4 }}>
                          <Typography variant="body2" color="text.secondary">
                            No records found.
                          </Typography>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              <Box sx={{ px: 2, py: 2, display: "flex", justifyContent: "flex-end" }}>
                <Button
                  variant="contained"
                  onClick={handleCompleteTrip}
                  color="primary"
                  className="button-variant-contained"
                >
                  Complete Trip
                </Button>
              </Box>
            </Paper>
          </Box>
        </Box>

      <Dialog
        open={showDriverCollectDialog}
        onClose={() => {
          setShowDriverCollectDialog(false);
          setDriverCollectForm({
            amount: "",
            type: "",
            paid_by: "",
            cheque: "",
            remark: "",
          });
          setPaymentType("");
          setChequeVisible(false);
        }}
        maxWidth="md"

        PaperProps={{
          sx: {
            borderRadius: 2,
          },
        }}
      >
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography  className="page-title">
            Edit Driver Collect Amount
          </Typography>
          <IconButton
            onClick={() => {
              setShowDriverCollectDialog(false);
              setDriverCollectForm({
                amount: "",
                type: "",
                paid_by: "",
                cheque: "",
                remark: "",
              });
              setPaymentType("");
              setChequeVisible(false);
            }}
            sx={{ color: '#637381' }}
          >
            <Iconify icon="mdi:close" width={24} height={24} />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Box component="form" onSubmit={handleDriverCollectSubmit} sx={{ mt: 1 }}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  className="form-input-border"
                  label="Amount"
                  type="number"
                  inputProps={{ step: "0.01" }}
                  value={driverCollectForm.amount}
                  onChange={(e) => handleDriverCollectFormChange("amount", e.target.value)}
                  required
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: '8px',
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <FormControl component="fieldset" required>
                  <Typography variant="body2" sx={{ mb: 0.5, fontWeight: 500 }}>
                    Type
                  </Typography>
                  <RadioGroup
                    row
                    value={driverCollectForm.type}
                    onChange={(e) => handleDriverCollectFormChange("type", e.target.value)}
                  >
                    <FormControlLabel value="positive"  control={<Radio />} label="Addition" />
                    <FormControlLabel value="negative" control={<Radio />} label="Subtraction" />
                  </RadioGroup>
                </FormControl>
              </Grid>
              {driverCollectData.type === "" && (
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth required>
                    <InputLabel>Paying by *</InputLabel>
                    <Select
                      value={paymentType}
                      label="Paying by *"
                      onChange={handlePaymentTypeChange}
                      sx={{
                        borderRadius: '8px',
                      }}
                    >
                      <MenuItem value="">Select Payment Type</MenuItem>
                      <MenuItem value="cash">Cash</MenuItem>
                      <MenuItem value="CC">Credit Card</MenuItem>
                      <MenuItem value="Cheque">Cheque</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              )}
              {isChequeVisible && (
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Cheque No *"
                    value={driverCollectForm.cheque}
                    onChange={(e) => handleDriverCollectFormChange("cheque", e.target.value)}
                    placeholder="Enter Cheque No"
                    required
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '8px',
                      
                      },
                    }}
                  />
                </Grid>
              )}
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  className="form-input-border"
                  label="Remark"
                  multiline
                  minRows={3}
                  value={driverCollectForm.remark}
                  onChange={(e) => handleDriverCollectFormChange("remark", e.target.value)}
                  required
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: '8px',
    
                    },
                  }}
                />
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button
            onClick={() => {
              setShowDriverCollectDialog(false);
              setDriverCollectForm({
                amount: "",
                type: "",
                paid_by: "",
                cheque: "",
                remark: "",
              });
              setPaymentType("");
              setChequeVisible(false);
            }}
            className="button-variant-outlined"
            variant="outlined"
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleDriverCollectSubmit}
            className="button-variant-contained"
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={showReassignDialog}
        onClose={() => {
          setShowReassignDialog(false);
          setReassignComment("");
        }}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
          },
        }}
      >
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography className="page-title">
            Order Reassign
          </Typography>
          <IconButton
            onClick={() => {
              setShowReassignDialog(false);
              setReassignComment("");
            }}
            sx={{ color: '#637381' }}
          >
            <Iconify icon="mdi:close" width={24} height={24} />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          {reassignTripData && Object.keys(reassignTripData).length > 0 && (
            <>
              <Table size="small" sx={{ mb: 3 }} className="table-cell-border">
                <TableBody>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 500, width: '40%' }}>Customer (A/C No)</TableCell>
                    <TableCell>{reassignTripData.customerName} ({reassignTripData.customerAccountNo})</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 500 }}>Manifest No</TableCell>
                    <TableCell>{reassignTripData.manifestId}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 500 }}>Order ID</TableCell>
                    <TableCell>{reassignTripData.referenceNo}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 500 }}>Post code</TableCell>
                    <TableCell>{reassignTripData.postCode}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 500 }}>Route</TableCell>
                    <TableCell>{reassignTripData.route}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 500 }}>Status</TableCell>
                    <TableCell>{reassignTripData.sale_status}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
              <TextField
                label="Reason Note"
                className="form-input-border"
                value={reassignComment}
                onChange={handleReassignCommentChange}
                multiline
                minRows={3}
                fullWidth
                required
                placeholder="Reason For Reassigning"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '8px',
                  },
                }}
              />
            </>
          )}
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button
            onClick={() => {
              setShowReassignDialog(false);
              setReassignComment("");
            }}
            className="button-variant-outlined"
            variant="outlined"
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={ReassignFormData}
            className="button-variant-contained"
          >
            Update
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={showUndeliveredDialog}
        onClose={() => {
          setShowUndeliveredDialog(false);
          setReassignComment("");
        }}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
          },
        }}
      >
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography className="page-title">
            Order Undelivered
          </Typography>
          <IconButton
            onClick={() => {
              setShowUndeliveredDialog(false);
              setReassignComment("");
            }}
            sx={{ color: '#637381' }}
          >
            <Iconify icon="mdi:close" width={24} height={24} />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          {undeliveredTripData && Object.keys(undeliveredTripData).length > 0 && (
            <>
              <Table size="small" sx={{ mb: 3 }} className="table-cell-border">
                <TableBody>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 500, width: '40%' }}>Customer (A/C No)</TableCell>
                    <TableCell>{undeliveredTripData.customerName} ({undeliveredTripData.customerAccountNo})</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 500 }}>Manifest No</TableCell>
                    <TableCell>{undeliveredTripData.manifestId}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 500 }}>Order ID</TableCell>
                    <TableCell>{undeliveredTripData.referenceNo}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 500 }}>Post code</TableCell>
                    <TableCell>{undeliveredTripData.postCode}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 500 }}>Route</TableCell>
                    <TableCell>{undeliveredTripData.route}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 500 }}>Status</TableCell>
                    <TableCell>{undeliveredTripData.sale_status}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
              <Box sx={{ mb: 2 }}>
                <Typography sx={{ fontWeight: 500, color: "#212b36", fontSize: "0.875rem", mb: 2 }}>
                  Products
                </Typography>
                <TableContainer sx={{ maxHeight: 300 }}>
                  <Table size="small" className="table-cell-border">
                    <TableHead>
                      <TableRow className="table-cell-header">
                        <TableCell width="5%">#</TableCell>
                        <TableCell width="30%">Product Name (code)</TableCell>
                        <TableCell width="10%">Order Qty</TableCell>
                        <TableCell width="10%">Delivery Qty</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {filteredProducts.map((product, index) => (
                        <TableRow key={product.productId} className="table-cell-style">
                          <TableCell>{index + 1}</TableCell>
                          <TableCell>{`${product.productName} (${product.productCode})`}</TableCell>
                          <TableCell>{`${product.qty} (${product.qtyType})`}</TableCell>
                          <TableCell>{`${product.order_qty} (${product.qtyType})`}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
              <TextField
                label="Reason Note"
                value={reassignComment}
                onChange={handleReassignCommentChange}
                multiline
                minRows={3}
                fullWidth
                required
                className="form-input-border"
                placeholder="Reason For Undelivered"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '8px',
              
                  },
                }}
              />
            </>
          )}
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button
            onClick={() => {
              setShowUndeliveredDialog(false);
              setReassignComment("");
            }}
            className="button-variant-outlined"
            variant="outlined"
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={UndeliveredFormData}
            className="button-variant-contained"
          >
            Update
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={showOrdersDeliveredDialog}
        onClose={() => setShowOrdersDeliveredDialog(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
          },
        }}
      >
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography className="page-title">
            Orders Delivered
          </Typography>
          <IconButton
            onClick={() => setShowOrdersDeliveredDialog(false)}
            sx={{ color: '#637381' }}
          >
            <Iconify icon="mdi:close" width={24} height={24} />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <TableContainer sx={{ width: "100%" }}>
            <Table
              size="medium"
              className="table-cell-border"
            >
              <TableHead>
                <TableRow className="table-cell-header">
                  <TableCell width="10%">#</TableCell>
                  <TableCell width="15%">Invoice No</TableCell>
                  <TableCell width="20%">Invoice Date</TableCell>
                  <TableCell width="40%">Customers (A/C No)</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {deliveredOrderDetails.map((item, index) => (
                  <TableRow
                    key={index}
                    hover
                    className="table-cell-style"
                  >
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>
                      <MuiLink
                        href={`${BASE_URL}/trip_summary/print/${item.orderId}`}
                        sx={{
                          color: "inherit",
                          textDecoration: "underline !important",
                          textDecorationColor: "currentColor",
                          textUnderlineOffset: "2px",
                          "&:hover": {
                            textDecoration: "underline !important",
                            textDecorationColor: "currentColor"
                          },
                        }}
                      >
                        {item.referenceNo}
                      </MuiLink>
                    </TableCell>
                    <TableCell>{item.invoice_date}</TableCell>
                    <TableCell>{item.customerName} ( {item.customerAccountNo} )</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button
            onClick={() => setShowOrdersDeliveredDialog(false)}
            className="button-variant-outlined"
            variant="outlined"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={showOrdersUndeliveredDialog}
        onClose={() => setShowOrdersUndeliveredDialog(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
          },
        }}
      >
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography className="page-title">
            Orders Undelivered
          </Typography>
          <IconButton
            onClick={() => setShowOrdersUndeliveredDialog(false)}
            sx={{ color: '#637381' }}
          >
            <Iconify icon="mdi:close" width={24} height={24} />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <TableContainer sx={{ width: "100%" }}>
            <Table
              size="medium"
              className="table-cell-border"
            >
              <TableHead>
                <TableRow className="table-cell-header">
                  <TableCell width="10%">#</TableCell>
                  <TableCell width="15%">Invoice No</TableCell>
                  <TableCell width="20%">Invoice Date</TableCell>
                  <TableCell width="40%">Customers (A/C No)</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {undeliveredOrderDetails.map((item, index) => (
                  <TableRow
                    key={index}
                    hover
                    className="table-cell-style"
                  >
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{item.referenceNo}</TableCell>
                    <TableCell>{item.invoice_date}</TableCell>
                    <TableCell>{item.customerName} ( {item.customerAccountNo} )</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button
            onClick={() => setShowOrdersUndeliveredDialog(false)}
            className="button-variant-outlined"
            variant="outlined"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={showPartialUndeliveredDialog}
        onClose={() => setShowPartialUndeliveredDialog(false)}
        maxWidth="xl"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
          },
        }}
      >
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography className="page-title">
            Partial Undelivered List
          </Typography>
          <IconButton
            onClick={() => setShowPartialUndeliveredDialog(false)}
            sx={{ color: '#637381' }}
          >
            <Iconify icon="mdi:close" width={24} height={24} />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <TableContainer sx={{ width: "100%" }}>
            <Table
              size="medium"
              className="table-cell-border"
            >
              <TableHead>
                <TableRow className="table-cell-header">
                  <TableCell width="10%">#</TableCell>
                  <TableCell width="15%">Order Id</TableCell>
                  <TableCell width="30%">Description</TableCell>
                  <TableCell width="10%">Order Qty</TableCell>
                  <TableCell width="10%">Order Type</TableCell>
                  <TableCell width="10%" align="right">Unit Price</TableCell>
                  <TableCell width="10%" align="right">{company_tax_type}</TableCell>
                  <TableCell width="10%" align="right">Total</TableCell>
                  <TableCell width="10%">Undeli.Qty</TableCell>
                  <TableCell width="10%">Reason</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {partialUndelivered.map((item, index) => {
                  const subtotal = parseFloat(item.subtotal);
                  const tax = parseFloat(item.tax);
                  const total = (subtotal + tax).toFixed(2);

                  return (
                    <TableRow
                      key={index}
                      hover
                      className="table-cell-style"
                    >
                      <TableCell >{index + 1}</TableCell>
                      <TableCell >{item.referenceNo}</TableCell>
                      <TableCell >
                        {item.productName} ( {item.productCode} )
                      </TableCell>
                      <TableCell >{item.quantity}</TableCell>
                      <TableCell >{item.order_type}</TableCell>
                      <TableCell align="right">{currencySymbol} {item.unit_price}
                        {currencySymbol} {item.unit_price}
                      </TableCell>
                      <TableCell align="right">{currencySymbol} {item.tax}
                        {currencySymbol} {item.tax}
                      </TableCell>
                      <TableCell align="right">{currencySymbol} {total}
                        {currencySymbol} {total}
                      </TableCell>
                      <TableCell >{item.not_delivered_qty}</TableCell>
                      <TableCell >{item.reason}</TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button
            onClick={() => setShowPartialUndeliveredDialog(false)}
            className="button-variant-outlined"
            variant="outlined"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={showUndeliveredProductsDialog}
        onClose={() => setShowUndeliveredProductsDialog(false)}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
          },
        }}
      >
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography className="page-title">
            Undelivered Products
          </Typography>
          <IconButton
            onClick={() => setShowUndeliveredProductsDialog(false)}
            sx={{ color: '#637381' }}
          >
            <Iconify icon="mdi:close" width={24} height={24} />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <TableContainer sx={{ width: "100%" }}>
            <Table
              size="medium"
              className="table-cell-border"
            >
              <TableHead>
                <TableRow className="table-cell-header">
                  <TableCell width="10%">#</TableCell>
                  <TableCell width="30%">Description</TableCell>
                  <TableCell width="10%">Order Qty</TableCell>
                  <TableCell width="10%">Order Type</TableCell>
                  <TableCell width="10%" align="right">Unit Price</TableCell>
                  <TableCell width="10%" align="right">{company_tax_type}</TableCell>
                  <TableCell width="10%" align="right">Total</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {undeliveredProductsList.map((item, index) => {
                  const unSubtotal = parseFloat(item.subtotal);
                  const unTax = parseFloat(item.item_tax);
                  const unTotal = (unSubtotal + unTax).toFixed(2);

                  return (
                    <TableRow
                      key={index}
                      hover
                      className="table-cell-style"
                    >
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>{item.productName} ( {item.productCode} )</TableCell>
                      <TableCell>{item.qty}</TableCell>
                      <TableCell>{item.qtyType}</TableCell>
                      <TableCell align="right">{currencySymbol} {item.unit_price}</TableCell>
                      <TableCell align="right">{currencySymbol} {item.item_tax}</TableCell>
                      <TableCell align="right">{currencySymbol} {unTotal}</TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button
            onClick={() => setShowUndeliveredProductsDialog(false)}
            variant="outlined"
            className="button-variant-outlined"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={showReturnDetailsDialog}
        onClose={() => setShowReturnDetailsDialog(false)}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
          },
        }}
      >
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography className="page-title">
            Return Details
          </Typography>
          <IconButton
            onClick={() => setShowReturnDetailsDialog(false)}
            sx={{ color: '#637381' }}
          >
            <Iconify icon="mdi:close" width={24} height={24} />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <TableContainer sx={{ width: "100%" }}>
            <Table
              size="medium"
              className="table-cell-border"
            >
              <TableHead>
                <TableRow className="table-cell-header">
                  <TableCell width="10%">#</TableCell>
                  <TableCell width="10%">Date</TableCell>
                  <TableCell width="15%">Return No</TableCell>
                  <TableCell width="25%">Customer (Ac/No)</TableCell>
                  <TableCell width="10%" align="right">Grand Total</TableCell>
                  <TableCell width="10%">Total Items</TableCell>
                  <TableCell width="10%">Return By</TableCell>
                  <TableCell width="10%">Status</TableCell>
                  <TableCell width="10%">Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {returnDetails.map((item, index) => {
                  let status = "";
                  let statusColor = "default";
                  if (item.is_accept === "Y") {
                    status = "Accept";
                    statusColor = "success";
                  } else if (item.is_accept === "R") {
                    status = "Reject";
                    statusColor = "error";
                  } else if (item.is_accept === "N") {
                    status = "Pending";
                    statusColor = "warning";
                  }
                  const rdTotal = parseFloat(item.grand_total);

                  return (
                    <TableRow
                      key={index}
                      hover
                      className="table-cell-style"
                    >
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>{item.date}</TableCell>
                      <TableCell>{item.reference_no}</TableCell>
                      <TableCell>{item.company} ( {item.accound_no} )</TableCell>
                      <TableCell align="right">{currencySymbol} {rdTotal}</TableCell>
                      <TableCell>{item.total_items}</TableCell>
                      <TableCell>{item.first_name} {item.last_name}</TableCell>
                      <TableCell>
                        <Chip
                          label={status}
                          color={statusColor}
                          size="small"
                          sx={{
                            fontWeight: 500,
                            fontSize: '0.7rem',
                            height: 24,
                            
                          }}
                        />
                      </TableCell>
                      <TableCell align="center" sx={{ py: 1, fontSize: "0.75rem", color: "#212b36" }}>
                        {status === "Pending" && (
                          <>
                            <IconButton
                              size="small"
                              onClick={(e) => handleReturnMenuOpen(e, item.id)}
                              sx={{
                                color: "#637381",
                                "&:hover": {
                                  backgroundColor: "rgba(0, 0, 0, 0.04)"
                                }
                              }}
                            >
                              <Iconify icon="eva:more-vertical-fill" width={20} height={20} />
                            </IconButton>
                            <Menu
                              anchorEl={returnMenuAnchor.el}
                              open={Boolean(returnMenuAnchor.el) && returnMenuAnchor.returnId === item.id}
                              onClose={handleReturnMenuClose}
                              anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'right',
                              }}
                              transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                              }}
                              PaperProps={{
                                sx: {
                                  minWidth: 200,
                                  borderRadius: 2,
                                  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
                                  mt: 1,
                                },
                              }}
                            >
                              <MenuItem onClick={() => handleReturnMenuAction('accept', item.id)}>
                                <ListItemIcon>
                                  <Iconify icon="eva:checkmark-circle-2-fill" width={20} height={20} />
                                </ListItemIcon>
                                <ListItemText>Accept Return</ListItemText>
                              </MenuItem>
                              <MenuItem onClick={() => handleReturnMenuAction('reject', item.id)}>
                                <ListItemIcon>
                                  <Iconify icon="eva:close-circle-fill" width={20} height={20} />
                                </ListItemIcon>
                                <ListItemText>Reject Return</ListItemText>
                              </MenuItem>
                            </Menu>
                          </>
                        )}
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button
            onClick={() => setShowReturnDetailsDialog(false)}
            className="button-variant-outlined"
            variant="outlined"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <Menu
        anchorEl={menuAnchor.el}
        open={Boolean(menuAnchor.el)}
        onClose={handleMenuClose}
        onClick={(e) => e.stopPropagation()}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        PaperProps={{
          onClick: (e) => e.stopPropagation(),
          sx: {
            minWidth: 200,
            borderRadius: 2,
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
            mt: 1,
          },
        }}
      >
        {menuAnchor.rowData?.sale_status === "Intransit" && (
          <>
            <MenuItem onClick={() => handleMenuAction('reassign', menuAnchor.rowData)}>
              <ListItemIcon>
                <Iconify icon="eva:refresh-fill" width={20} height={20} />
              </ListItemIcon>
              <ListItemText>Reassign Order</ListItemText>
            </MenuItem>
            <MenuItem onClick={() => handleMenuAction('undelivered', menuAnchor.rowData)}>
              <ListItemIcon>
                <Iconify icon="material-symbols-light:delivery-truck-bolt-outline" width={20} height={20} />
              </ListItemIcon>
              <ListItemText>Mark Undelivered</ListItemText>
            </MenuItem>
            <MenuItem onClick={() => handleMenuAction('edit', menuAnchor.rowData)}>
              <ListItemIcon>
                <Iconify icon="eva:edit-fill" width={20} height={20} />
              </ListItemIcon>
              <ListItemText>Edit Order</ListItemText>
            </MenuItem>
          </>
        )}
        {menuAnchor.rowData?.sale_status === "Delivered" && (
          <>
            <MenuItem onClick={() => handleMenuAction('edit', menuAnchor.rowData)}>
              <ListItemIcon>
                <Iconify icon="eva:edit-fill" width={20} height={20} />
              </ListItemIcon>
              <ListItemText>Edit Order</ListItemText>
            </MenuItem>
            <MenuItem onClick={() => handleMenuAction('proof', menuAnchor.rowData)}>
              <ListItemIcon>
                <Iconify icon="eva:image-fill" width={20} height={20} />
              </ListItemIcon>
              <ListItemText>View Proof of Delivery</ListItemText>
            </MenuItem>
          </>
        )}
      </Menu>

      {/* Proof of Delivery Modal */}
      <div
        className="modal fade"
        id="proofDeliveryModal"
        tabIndex="-1"
        aria-labelledby="proofDeliveryModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header d-flex justify-content-between align-items-center">
              <h5 className="modal-title" id="proofDeliveryModalLabel">
                Proof of Delivery
              </h5>

              <div className="d-flex align-items-center gap-2">
                <a id="downloadProofBtn" href="#" download="proof_of_delivery.jpg" title="download images" className="btn btn-primary btn-sm"
                >
                  <i className="bi bi-download me-1"></i>
                </a>

                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
            </div>

            <div className="modal-body text-center">
              <img
                id="proofDeliveryModalImg"
                src=""
                alt="Proof of Delivery"
                style={{ maxWidth: "100%", maxHeight: "400px" }}
              />
              <br />
            </div>
          </div>
        </div>
      </div>
      <Menu
        anchorEl={menuAnchor.el}
        open={Boolean(menuAnchor.el)}
        onClose={handleMenuClose}
        onClick={(e) => e.stopPropagation()}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        PaperProps={{
          onClick: (e) => e.stopPropagation(),
          sx: {
            minWidth: 200,
            borderRadius: 2,
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
            mt: 1,
          },
        }}
      >
        {menuAnchor.rowData?.sale_status === "Intransit" && (
          <>
            <MenuItem onClick={() => handleMenuAction('reassign', menuAnchor.rowData)}>
              <ListItemIcon>
                <Iconify icon="eva:refresh-fill" width={20} height={20} />
              </ListItemIcon>
              <ListItemText>Reassign Order</ListItemText>
            </MenuItem>
            <MenuItem onClick={() => handleMenuAction('undelivered', menuAnchor.rowData)}>
              <ListItemIcon>
                <Iconify icon="material-symbols-light:delivery-truck-bolt-outline" width={20} height={20} />
              </ListItemIcon>
              <ListItemText>Mark Undelivered</ListItemText>
            </MenuItem>
            <MenuItem onClick={() => handleMenuAction('edit', menuAnchor.rowData)}>
              <ListItemIcon>
                <Iconify icon="eva:edit-fill" width={20} height={20} />
              </ListItemIcon>
              <ListItemText>Edit Order</ListItemText>
            </MenuItem>
          </>
        )}
        {menuAnchor.rowData?.sale_status === "Delivered" && (
          <>
            <MenuItem onClick={() => handleMenuAction('edit', menuAnchor.rowData)}>
              <ListItemIcon>
                <Iconify icon="eva:edit-fill" width={20} height={20} />
              </ListItemIcon>
              <ListItemText>Edit Order</ListItemText>
            </MenuItem>
            <MenuItem onClick={() => handleMenuAction('proof', menuAnchor.rowData)}>
              <ListItemIcon>
                <Iconify icon="eva:image-fill" width={20} height={20} />
              </ListItemIcon>
              <ListItemText>View Proof of Delivery</ListItemText>
            </MenuItem>
          </>
        )}
      </Menu>
    </>
  );
};

export default OpenTripSummary;
